import type { NormalizedChartData } from "./dashboardChartData";
import { displayLocale, formatChartDay } from "./localization";

const dailyBucketSeconds = 86_400;

export function usesDailyMeasurementAxis(bucketSeconds: number) {
  return bucketSeconds >= dailyBucketSeconds;
}

export function measurementAxisValues(chart: NormalizedChartData) {
  if (!usesDailyMeasurementAxis(chart.bucketSeconds)) return [];
  const intervalMilliseconds = chart.bucketSeconds * 1000;
  if (!Number.isFinite(chart.rangeStart) || !Number.isFinite(chart.rangeEnd) || chart.rangeEnd <= chart.rangeStart || !Number.isFinite(intervalMilliseconds)) return [];
  const timestamps: number[] = [];
  for (let timestamp = chart.rangeStart; timestamp < chart.rangeEnd; timestamp += intervalMilliseconds) timestamps.push(timestamp);
  return timestamps;
}

export function measurementAxisFormatter(timeZone: string, bucketSeconds: number, rangeMilliseconds: number) {
  if (rangeMilliseconds > 36 * 60 * 60 * 1000 || usesDailyMeasurementAxis(bucketSeconds)) {
    return (value: number) => formatChartDay(value, timeZone);
  }
  const dateTime = new Intl.DateTimeFormat(displayLocale, { day: "numeric", month: "numeric", hour: "2-digit", minute: "2-digit", timeZone });
  return (value: number) => dateTime.format(new Date(value));
}
